export default __webpack_public_path__ + "static/media/AutoWF3.0d6705bd.png";